<template>
  <div
    class="home"
    :class="{iehack:$isIe9}"
  >
    <!-- <div id="nav">
      <router-link to="/">Home</router-link>
      <router-link to="/about">About</router-link>
    </div>-->
    <div class="fix-btns">
      <a>
        <div class="fbtn fbtn1">
          <div class="fpanel">
            <span>免费电话：</span>
            <a href="tel:4006222312">400-6222-312</a>
          </div>
        </div>
      </a>
      <a>
        <div class="fbtn fbtn2">
          <div class="fpanel">
            <div class="fbt">
              <img
                src="../assets/usericon.png"
                alt="蓝凌客服"
              />
              <span>您好！</span>
              <span>我是蓝桥小二</span>
              <p>一对一专属服务/产品培训服务</p>
            </div>
            <div class="fb-qr">
              <img
                src="../assets/dxe.png"
                alt
              />
              <p>手机钉钉扫码咨询</p>
              <span>工作时间：周一至周五10:00-19:00</span>
            </div>
          </div>
        </div>
      </a>
      <a>
        <div
          class="fbtn fbtn3"
          ref="ftbtn3"
        >
          <div class="fpanel">
            <div class="qr1">
              <div>下载掌上蓝凌</div>
              <div class="img">
                <img
                  src="../assets/download.png"
                  alt
                />
              </div>
            </div>
            <div class="qr2">
              <div>体验组织二维码</div>
              <div class="img">
                <img
                  src="../assets/joinus.jpg"
                  alt
                />
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
    <header>
      <div
        class="headerbg"
        ref="headerbg"
      ></div>
      <div class="center">
        <a href="/">
          <img
            src="../assets/logowhite.png"
            class="black"
            ref="black"
            alt="蓝桥智能门户"
          />
          <img
            src="../assets/logotitle.png"
            class="white"
            ref="white"
            alt="蓝桥智能门户"
          />
        </a>
        <button
          @mouseenter="hoverHandle('in')"
          @mouseleave="hoverHandle('out')"
          :class="{'deep-btn':deepColorBtn}"
        >立即体验</button>
      </div>
    </header>
    <div class="banner">
      <div class="banner-left"></div>
      <div class="banner-right"></div>
      <div class="banner-wrap">
        <h2 class="normalTitle">蓝桥</h2>
        <div
          class="b-title-m"
          id="bannerh2"
        >
          蓝凌
          <!-- <img
            src="../assets/x.png"
            alt
          /> -->
          ×
          钉钉
        </div>
        <h1 class="normalTitle">企业IT系统连接钉钉的适配器</h1>

        <div class="btn">
          <button
            id="bannerbtn"
            @mouseenter="hoverHandle('in')"
            @mouseleave="hoverHandle('out')"
          >立即体验</button>
        </div>
      </div>
      <div class="banner-bottom-1">
        <barrage />
      </div>
    </div>

    <div class="panel-page-parent">
      <div class="panel-bg">
        <div class="panel-parent">
          <div
            class="panel"
            id="hpanel"
          >
            <div class="right-bg"></div>
            <div class="item item1">
              <img
                src="../assets/icon-01@2x.png"
                alt="专属钉钉"
              />
              <h3>统一通讯录</h3>
              <p>建立企业统一用户管理中心</p>
              <p>全面实现钉钉组织在线</p>
            </div>
            <div class="item item2">
              <img
                src="../assets/icon-02@2x.png"
                alt="统一组织"
              />
              <h3>统一系统</h3>
              <p>全面集成内部各个系统</p>
              <p>实现一键免登</p>
            </div>
            <div class="item item3">
              <img
                src="../assets/icon-03@2x.png"
                alt="统一门户"
              />
              <h3>统一消息</h3>
              <p>企业内各个系统的消息</p>
              <p>全面实现统一待办、待阅推送</p>
            </div>
            <div
              class="item item4"
              style="border-right:none;"
            >
              <img
                src="../assets/icon-04@2x.png"
                alt="应用集成"
              />
              <h3>统一门户</h3>
              <p>以钉钉工作台为统一移动门户</p>
              <p>入口，快速便捷</p>
            </div>
            <div style="clear:both;"></div>
          </div>
        </div>
        <div class="pannel-bg-ab"></div>
      </div>

      <div class="page-parent">
        <div class="page">
          <div class="center">
            <h2 class="normalTitle product-title">
              <p>PRODUCT FUNCTIONS</p>
              产品功能
            </h2>
          </div>

          <div class="line">
            <img
              src="../assets/function1.png"
              alt="组织集成"
              class="funcl"
              style="width:500px;height:400px"
              width="500"
              height="400"
            />
            <div class="funcr">
              <h3>
                组织集成
                <img
                  src="../assets/text01.png"
                  alt="01"
                />
              </h3>
              <div class="contact-box box-1">
                <p>快速接入企业第三方组织数据源，</p>
                <p>同步到钉钉，实现企业组织在线</p>
              </div>
            
            </div>
          </div>
          <div class="line">
            <div
              class="funcl"
              style="padding-left:0;"
            >
              <h3>
                SSO集成
                <img
                  src="../assets/text02.png"
                  alt="02"
                />
              </h3>
              <div class="contact-box box-2">
                <p>提供SSO集成服务，实现企业内各系统</p>
                <p>和钉钉的SSO免登服务</p>
              </div>

            </div>
            <img
              src="../assets/function2.png"
              alt="SSO集成"
              class="funcr"
              style="width:533px;height:427px"
              width="533"
              height="423"
            />
          </div>
          <div class="line">
            <img
              src="../assets/function3.png"
              alt="消息集成"
              class="funcl"
              style="width:500px;height:470px"
              width="500"
              height="470"
            />
            <div class="funcr">
              <h3>
                消息集成
                <img
                  src="../assets/text03.png"
                  alt="03"
                />
              </h3>
              <div class="contact-box box-3">
                <p>实现企业内各系统应用的消息，通过蓝桥服务，</p>
                <p>统一待办待阅的消息推送</p>
              </div>
           
            </div>
          </div>
          <div class="line-parent">
            <div class="line">
              <div
                class="funcl"
                style="padding-left:0;"
              >
                <h3>
                  门户集成
                  <img
                    src="../assets/text04.png"
                    alt="04"
                  />
                </h3>
                <div class="contact-box box-4">
                  <p>提供丰富的门户组件，以钉钉DingPaaS门户</p>
                  <p>为平台，实现第三方数据源在门户上的展示</p>
                </div>
              </div>
              <img
                class="funcr"
                src="../assets/function4.png"
                alt="门户集成"
                style="width:500px;height:400px"
                width="500"
                height="400"
              />
            </div>
            <div class="right-bg-4">

            </div>
          </div>
          <div
            class="line"
            style="margin-bottom:0;"
          >
            <img
              src="../assets/function5.png"
              alt="智能工具箱"
              class="funcl"
              style="width:500px;height:530px"
              width="500"
              height="530"
            />
            <div class="funcr">
              <h3>智能工具箱
                <img
                  src="../assets/text05.png"
                  alt="05"
                />
              </h3>
              <div class="contact-box box-5">
                <p>蓝桥API管控、应用管理、智能建群…</p>
              </div>

            </div>
          </div>
        </div>
        <div class="pannel-bg-ab"></div>
      </div>
      <div class="panel-page-parent-bg"></div>
    </div>

    <!-- <div class="scenes">
      <h2 class="normalTitle">典型集成场景</h2>
      <LTab class="component" :active="componentShow">
        <div slot="0" class="s-slot" title="门户集成">
          <div class="info-block">
            <h3>功能介绍</h3>
            <p>
              蓝桥智能门户和钉钉天然融合，提供SSO服务器，能快速集成企业主流的应用，实现在专属钉钉上统一登录；
              蓝桥提供统一消息集成组件，封装国内外主流应用集成接口，实现系统统一消息推送，统一钉钉待办提醒。
            </p>
          </div>
          <img src="../assets/01.jpg" alt="门户集成" />
        </div>
        <div slot="1" class="s-slot" title="业务集成">
          <div class="info-block">
            <h3>功能介绍</h3>
            <p>提供与SAP、k3、EAS、U8、NC系统集成组件，内置应用函数并对其进行管理，通过系统提供的流程、报表中心或开发平台，实现与系统快速集成。</p>
          </div>
          <img src="../assets/02.jpg" alt="业务集成" />
        </div>
        <div slot="2" class="s-slot" title="邮件集成">
          <div class="info-block">
            <h3>功能介绍</h3>
            <p>1、提供用户统一邮件客户端</p>
            <p>2、实现邮件系统SSO</p>
            <p>3、实现邮件提醒和收发功能</p>
          </div>
          <img src="../assets/03.jpg" alt="邮件集成" />
        </div>
        <div slot="3" class="s-slot" title="报表集成">
          <div class="info-block">
            <h3>功能介绍</h3>
            <p>
              系统数据图表展现方式，可以根据要求在门户中展现。
              系统可集成常见的报表工具，并满足企业各种复杂的数据显示的需求。
            </p>
          </div>
          <img src="../assets/04.jpg" alt="报表集成" />
        </div>
        <div slot="4" class="s-slot" title="日程集成">
          <div class="info-block">
            <h3>功能介绍</h3>
            <p>系统提供与Echange、印象笔记、Google日历的日程数据集成，实现相关系统的数据同步到蓝桥，同时实现蓝桥和钉钉日程的双向同步。</p>
          </div>
          <img src="../assets/05.jpg" alt="日程集成" />
        </div>
        <div slot="5" class="s-slot" title="云开发平台">
          <div class="info-block">
            <h3>功能介绍</h3>
            <p>云开发平台主要由“应用建模”和“移动建模”俩大块组成。应用建模专注于无代码化自定义开发应用模块；移动建模专注于无代码化自定义开发移动应用。</p>
          </div>
          <img src="../assets/06.jpg" alt="云开发平台" />
        </div>
      </LTab>
    </div> -->
    <div class="csae-parent">
      <div class="csae">
        <h2 class="normalTitle product-title">典型客户案例</h2>
        <div class="logos">
          <img
            src="../assets/logo01.png"
            class="left"
            alt="浙江大学"
          />
          <img
            src="../assets/logo02.png"
            alt="越秀地产"
          />
          <img
            src="../assets/logo03.png"
            class="right"
            alt="JINKE金科"
          />
          <img
            src="../assets/logo04.png"
            class="left"
            alt="立白"
          />
          <img
            src="../assets/logo05.png"
            alt="广东农信"
          />
          <img
            src="../assets/logo06.png"
            class="right"
            alt="长城汽车"
          />
          <img
            src="../assets/logo07.png"
            class="left"
            alt="立白"
          />
          <img
            src="../assets/logo08.png"
            alt="广东农信"
          />
          <img
            src="../assets/logo09.png"
            class="right"
            alt="长城汽车"
          />
          <!-- <div class="line1"></div>
          <div class="line2"></div>
          <div class="line3"></div> -->
        </div>
      </div>
    </div>

    <div>
      <iframe
        src="./form.html"
        style="width:100%;height:503px;border:none;"
      ></iframe>
    </div>
    <footer>
      <div class="links">
        <a href="tel:400-6222-312">400-6222-312</a>
        <div class="logotext">
          <img
            src="../assets/landraytext.png"
            alt="landray"
          />
          <p>深圳市蓝凌软件股份有限公司</p>
        </div>
        <p style="color:#333">深圳市南山区深南大道9966号威盛科技大厦10楼</p>
        <p>
          邮编：518057 总机：
          <a href="tel:0755-26012345">0755-26012345</a> 传真：0755-26710099
        </p>
      </div>
      <div class="copyright">
        <p>
          版权所有 © 2001-2019
          <a
            href="http://www.miibeian.gov.cn"
            rel="nofollow"
          >粤ICP备09200185号</a>
        </p>
      </div>
    </footer>
  </div>
</template>
<script>
import LTab from '../components/LTab.vue'
import Barrage from '../components/Barrage.vue'
import './home.scss'

export default {
  name: 'home',
  data() {
    return {
      componentShow: false,
      deepColorBtn: false
    }
  },
  components: { LTab, Barrage },
  mounted() {
    window.addEventListener(
      'scroll',
      () => {
        document.body.className = 'disable-hover'
        window.clearTimeout(window.isScrolling)
        window.isScrolling = setTimeout(() => {
          document.body.className = ''
        }, 66)

        const scrollheight = this.getScrollTop()
        if (scrollheight < 145) {
          window.requestAnimationFrame(() => {
            const opacity = scrollheight / 145
            this.$refs.headerbg.style.opacity = opacity
            this.$refs.black.style.opacity = opacity
            this.$refs.white.style.opacity = 1 - opacity
            this.deepColorBtn = false
          })
        } else {
          this.$refs.black.style.opacity = 1
          this.$refs.white.style.opacity = 0
          this.$refs.headerbg.style.opacity = 1
          this.headerBgShow = true
          this.deepColorBtn = true
        }
        return false
      },
      () => {
        document.body.className = ''
      }
    )
    this.$nextTick(() => {
      // 组件监听
      this.$scroll.reveal('.component', {
        duration: 500,
        reset: true,
        beforeReveal: this.componentReveal.bind(this, true),
        afterReset: this.componentReveal.bind(this, false)
      })
      this.$scroll.reveal('.normalTitle', {
        duration: 1000,
        reset: true,
        beforeReveal: this.myCallback.bind(
          this,
          'normalTitle bannerh1Show product-title'
        ),
        afterReset: this.myCallback.bind(this, 'normalTitle')
      })
      this.$scroll.reveal('#bannerh2', {
        duration: 500,
        reset: true,
        beforeReveal: this.myCallback.bind(this, 'b-title-m bannerh2Show'),
        afterReset: this.myCallback.bind(this, 'b-title-m')
      })
      this.$scroll.reveal('#bannerbtn', {
        duration: 500,
        reset: true,
        beforeReveal: this.myCallback.bind(this, 'bannerbtnShow'),
        afterReset: this.myCallback.bind(this, '')
      })
      // this.$scroll.reveal('#hpanel', {
      //   duration: 1000,
      //   reset: true,
      //   beforeReveal: this.myCallback.bind(this, 'panel panelExpand'),
      //   afterReset: this.myCallback.bind(this, 'panel'),
      // });
      // this.$scroll.reveal('.item1', {
      //   distance: '20px',
      //   reset: true,
      //   delay: 1300,
      //   opacity: 0,
      //   easing: 'linear',
      // });
      // this.$scroll.reveal('.item2', {
      //   distance: '20px',
      //   reset: true,
      //   delay: 1500,
      //   opacity: 0,
      //   easing: 'linear',
      // });
      // this.$scroll.reveal('.item3', {
      //   distance: '20px',
      //   reset: true,
      //   delay: 1700,
      //   opacity: 0,
      //   easing: 'linear',
      // });
      // this.$scroll.reveal('.item4', {
      //   distance: '20px',
      //   reset: true,
      //   delay: 1900,
      //   opacity: 0,
      //   easing: 'linear',
      // });
      // this.$scroll.reveal('.item5', {
      //   distance: '20px',
      //   reset: true,
      //   delay: 2100,
      //   opacity: 0,
      //   easing: 'linear',
      // });
      // 功能特性
      this.$scroll.reveal('.funcl', {
        duration: 500,
        reset: true,
        beforeReveal: this.myCallback.bind(this, 'funcl fadeInLeft'),
        afterReset: this.myCallback.bind(this, '')
      })
      this.$scroll.reveal('.funcr', {
        duration: 500,
        reset: true,
        beforeReveal: this.myCallback.bind(this, 'funcr fadeInRight'),
        afterReset: this.myCallback.bind(this, '')
      })
    })
  },
  methods: {
    hoverHandle(type) {
      if (type === 'in') {
        this.$refs.ftbtn3.className = 'fbtn fbtn3 hover'
      } else {
        this.$refs.ftbtn3.className = 'fbtn fbtn3'
      }
    },
    myCallback(className, el) {
      const element = el
      element.className = className
    },
    componentReveal(status) {
      this.componentShow = status
    },
    getScrollTop() {
      let stop
      if (document.documentElement && document.documentElement.scrollTop) {
        stop = document.documentElement.scrollTop
      } else if (document.body) {
        stop = document.body.scrollTop
      }
      return stop
    }
  }
}
</script>
